<template>
    <!-- <app-layout> -->

    <!-- <template #header>
            <Subnav></Subnav>
        </template> -->


    <div class="py-12 w-full">
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">


            <div class="flex flex-row">
                <div class="flex flex-col flex-grow">
                    <h1 v-if="has_onboarding_done" class="text-blue-500 text-3xl font-bold">Welcome back in the Quick
                        Start
                        guide!</h1>
                    <h1 v-else class="text-blue-500 text-3xl font-bold">Welcome to {{ app_name }}, {{
                        $page.props.user.name.split(' ')[0] }}!</h1>

                    <p v-if="has_onboarding_done" class="pb-8 text-gray-500 text-lg">Explore how you can use {{ app_name
                        }}
                        in various ways, and learn with the videos.</p>
                    <p v-else class="pb-8 text-gray-500 text-lg">Discover {{ app_name }} in less than 2 min and get
                        personal
                        with your customers starting today.</p>
                </div>
                <div v-if="!_has_onboarding_done" class="flex flex-col justify-start">
                    <inertia-link :href="route('library.incoming')" @click="skip"
                        class="inline-flex items-center px-4 py-2 font-semibold text-xs text-gray-600 uppercase tracking-widest hover:text-gray-500  active:text-gray-800 transition mt-1">
                        Skip <span class="hidden md:inline ml-1">onboarding</span>
                    </inertia-link>
                </div>
            </div>

            <quick-start-nav></quick-start-nav>

            <div class="bg-white shadow-xl sm:rounded-b-lg sm:rounded-tr-lg">


                <div class="grid grid-cols-2 gap-4 py-20">

                    <div class="pl-10 grid">
                        <ul class="list-none text-lg text-gray-600">


                            <li class="text-green-500 mb-3 p-3 rounded bg-green-50 border border-green-100">
                                <vue-feather type="check-circle" class="h-4 w-4 align-middle mr-2 mb-1"></vue-feather>
                                <span>Create your account</span>
                            </li>


                            <li v-if="_has_customize"
                                class="text-green-500 mb-3 p-3 rounded bg-green-50 border border-green-100">
                                <vue-feather type="check-circle" class="h-4 w-4 align-middle mr-2 mb-1"></vue-feather>
                                Choose your recorder appearance
                            </li>
                            <a v-else id="widget_settings_appearance" href="#"
                                @click.prevent.stop="modal_type = 'appearance'; openModal()"
                                class="block mb-3 hover:text-gray-800 p-3 rounded bg-gray-50 border border-gray-100"
                                title="Appearance">
                                <vue-feather type="circle" class="h-4 w-4 align-middle mr-2 mb-1"></vue-feather>
                                Choose your recorder appearance</a>

                            <li v-if="_has_snippet"
                                class="text-green-500 mb-3 p-3 rounded bg-green-50 border border-green-100">
                                <vue-feather type="check-circle" class="h-4 w-4 align-middle mr-2 mb-1"></vue-feather>
                                Add snippet (optional)
                            </li>
                            <a v-else id="widget_settings_appearance" href="#"
                                @click.prevent.stop="modal_type = 'snippet'; openModal()"
                                class="block mb-3 hover:text-gray-800 p-3 rounded bg-gray-50 border border-gray-100"
                                title="Appearance">
                                <vue-feather type="circle" class="h-4 w-4 align-middle mr-2 mb-1"></vue-feather>
                                Add snippet (optional)</a>

                            <template v-if="tab == 'standalone'">
                                <li v-if="_has_send"
                                    class="text-green-500 mb-3 p-3 rounded bg-green-50 border border-green-100">
                                    <vue-feather type="check-circle"
                                        class="h-4 w-4 align-middle mr-2 mb-1"></vue-feather>
                                    Record a video
                                </li>
                                <li v-else id="has_send" class="mb-3 p-3 rounded bg-gray-50 border border-gray-100">
                                    <span><vue-feather type="circle"
                                            class="h-4 w-4 align-middle mr-2 mb-1"></vue-feather>
                                        Record a video</span>
                                    <a href="#" @mouseover="hovering('record', true)"
                                        @mouseleave="hovering('record', false)" class="ml-4 align-middle" id="glowred"
                                        v-tippy="{ content: 'Use the top-right glowing button' }">
                                        <vue-feather type="help-circle" class="h-4 w-4 align-middle mb-2"></vue-feather>
                                    </a>
                                </li>
                            </template>

                            <template v-if="tab == 'standalone'">
                                <li v-if="_has_require"
                                    class="text-green-500 mb-3 p-3 rounded bg-green-50 border border-green-100">
                                    <vue-feather type="check-circle"
                                        class="h-4 w-4 align-middle mr-2 mb-1"></vue-feather>
                                    Request a recording
                                </li>
                                <li v-else id="has_require" class="mb-3 p-3 rounded bg-gray-50 border border-gray-100">
                                    <span><vue-feather type="circle"
                                            class="h-4 w-4 align-middle mr-2 mb-1"></vue-feather>
                                        Request a recording</span>
                                    <a href="#" @mouseover="hovering('copy', true)"
                                        @mouseleave="hovering('copy', false)" class="ml-4 align-middle" id="glowblu"
                                        v-tippy="{ content: 'Use the top-right glowing button' }">
                                        <vue-feather type="help-circle" class="h-4 w-4 align-middle mb-2"></vue-feather>
                                    </a>
                                </li>
                            </template>

                            <template v-if="tab == 'helpdesk'">


                                <div class="flex flex-row justify-start mb-3 p-3 rounded border "
                                    :class="{ 'bg-green-50  border-green-100': _has_helpdesk, 'bg-gray-50  border-gray-100': !_has_helpdesk }">
                                    <div v-if="_has_helpdesk" class="flex self-center text-green-500">
                                        <vue-feather type="check-circle" class="h-4 w-4 self-center mr-2"></vue-feather>
                                        Your are connected to
                                    </div>
                                    <div class="flex self-center" v-else>
                                        <vue-feather type="circle" class="h-4 w-4 self-center mr-2"></vue-feather>
                                        Your helpdesk:
                                    </div>

                                    <jet-dropdown align="left" width="36" class="flex self-center">
                                        <template #trigger>
                                            <span class="inline-flex rounded-md">
                                                <button type="button"
                                                    class="inline-flex items-center px-2 py-2 border border-transparent leading-4 font-medium rounded-md text-blue-500 bg-transparent hover:bg-white hover:text-blue-700 focus:outline-none focus:bg-gray-50 active:bg-gray-50 transition">

                                                    <span v-if="tab2 == 'intercom'" class="font-bold">
                                                        Intercom
                                                    </span>
                                                    <span v-else-if="tab2 == 'zendesk'" class="font-bold">
                                                        Zendesk
                                                    </span>
                                                    <span v-else-if="tab2 == 'jira'" class="font-bold">
                                                        Jira
                                                    </span>
                                                    <span v-else-if="tab2 == 'helpscout'" class="font-bold">
                                                        Helpscout
                                                    </span>
                                                    <span v-else-if="tab2 == 'freshchat'" class="font-bold">
                                                        Freshchat
                                                    </span>
                                                    <span v-else-if="tab2 == 'freshdesk'" class="font-bold">
                                                        Freshdesk
                                                    </span>
                                                    <span v-else v-html="default_integration()"
                                                        :class="{ 'font-bold': has_helpdesk }">

                                                    </span>

                                                    <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 20 20" fill="currentColor">
                                                        <path fill-rule="evenodd"
                                                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                            clip-rule="evenodd" />

                                                    </svg>
                                                </button>
                                            </span>
                                        </template>

                                        <template #content>
                                            <inertia-link :href="route('quick_start', { tab: 'helpdesk', tab2: 'intercom' })"
                                                class="block px-4 py-2 leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition rounded flex flex-row"
                                                :class="{ 'text-blue-500 font-bold': tab2 == 'intercom' || has_integration('intercom') }"
                                                @click.prevent="updateHelpdesk('intercom')">
                                                <span class="flex flex-grow">Intercom</span>
                                                <vue-feather v-if="tab2 == 'intercom'" type="check"
                                                    class="w-4 h-4 ml-2 self-center"></vue-feather>
                                            </inertia-link>
                                            <inertia-link :href="route('quick_start', { tab: 'helpdesk', tab2: 'zendesk' })"
                                                class="block px-4 py-2 leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition rounded flex flex-row"
                                                :class="{ 'text-blue-500 font-bold': tab2 == 'zendesk' || has_integration('zendesk') }"
                                                @click.prevent="updateHelpdesk('zendesk')">
                                                <span class="flex flex-grow">Zendesk</span>
                                                <vue-feather v-if="tab2 == 'zendesk'" type="check"
                                                    class="w-4 h-4 ml-2 self-center"></vue-feather>
                                            </inertia-link>
                                            <inertia-link :href="route('quick_start', { tab: 'helpdesk', tab2: 'jira' })"
                                                class="block px-4 py-2 leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition rounded flex flex-row"
                                                :class="{ 'text-blue-500 font-bold': tab2 == 'jira' || has_integration('jira') }"
                                                @click.prevent="updateHelpdesk('jira')">
                                                <span class="flex flex-grow">Jira</span>
                                                <vue-feather v-if="tab2 == 'jira'" type="check"
                                                    class="w-4 h-4 ml-2 self-center"></vue-feather>
                                            </inertia-link>
                                            <inertia-link
                                                :href="route('quick_start', { tab: 'helpdesk', tab2: 'helpscout' })"
                                                class="block px-4 py-2 leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition rounded flex flex-row"
                                                :class="{ 'text-blue-500 font-bold': tab2 == 'helpscout' || has_integration('helpscout') }"
                                                @click.prevent="updateHelpdesk('helpscout')">
                                                <span class="flex flex-grow">Helpscout</span>
                                                <vue-feather v-if="tab2 == 'helpscout'" type="check"
                                                    class="w-4 h-4 ml-2 self-center"></vue-feather>
                                            </inertia-link>
                                            <inertia-link
                                                :href="route('quick_start', { tab: 'helpdesk', tab2: 'freshchat' })"
                                                class="block px-4 py-2 leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition rounded flex flex-row"
                                                :class="{ 'text-blue-500 font-bold': tab2 == 'freshchat' || has_integration('freshchat') }"
                                                @click.prevent="updateHelpdesk('freshchat')">
                                                <span class="flex flex-grow">Freshchat</span>
                                                <vue-feather v-if="tab2 == 'freshchat'" type="check"
                                                    class="w-4 h-4 ml-2 self-center"></vue-feather>
                                            </inertia-link>
                                            <inertia-link
                                                :href="route('quick_start', { tab: 'helpdesk', tab2: 'freshdesk' })"
                                                class="block px-4 py-2 leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition rounded flex flex-row"
                                                :class="{ 'text-blue-500 font-bold': tab2 == 'freshdesk' || has_integration('freshdesk') }"
                                                @click.prevent="updateHelpdesk('freshdesk')">
                                                <span class="flex flex-grow">Freshdesk</span>
                                                <vue-feather v-if="tab2 == 'freshdesk'" type="check"
                                                    class="w-4 h-4 ml-2 self-center"></vue-feather>
                                            </inertia-link>
                                        </template>
                                    </jet-dropdown>
                                    <div class="flex flex-col justify-center self-center" v-if="tab2 && !_has_helpdesk">
                                        <a href="#" class="hover:text-gray-800" title="Connect to your helpdesk"
                                            @click.prevent.stop="modal_type = 'integrations'; openModal()">
                                            connect</a>
                                    </div>
                                </div>

                            </template>

                            <template v-if="tab == 'inapp'">
                                <li v-if="_has_launcher"
                                    class="text-green-500 mb-3 p-3 rounded bg-green-50 border border-green-100">
                                    <vue-feather type="check-circle"
                                        class="h-4 w-4 align-middle mr-2 mb-1"></vue-feather>
                                    {{ app_name }} in your app: choose your launcher
                                </li>
                                <a v-else href="#" @click.prevent.stop="modal_type = 'launcher'; openModal()"
                                    id="widget_settings_launcher"
                                    class="block mb-3 hover:text-gray-800 p-3 rounded bg-gray-50 border border-gray-100"
                                    title="Launcher">
                                    <vue-feather type="circle" class="h-4 w-4 align-middle mr-2 mb-1"></vue-feather>
                                    {{ app_name }} in your app: choose your launcher</a>


                                <li v-if="_has_install"
                                    class="text-green-500 mb-3 p-3 rounded bg-green-50 border border-green-100">
                                    <vue-feather type="check-circle"
                                        class="h-4 w-4 align-middle mr-2 mb-1"></vue-feather>
                                    {{ app_name }} in your app: install
                                </li>
                                <a v-else href="#" @click.prevent.stop="modal_type = 'installation'; openModal()"
                                    class="block mb-3 hover:text-gray-800 p-3 rounded bg-gray-50 border border-gray-100"
                                    title="Installation">
                                    <vue-feather type="circle" class="h-4 w-4 align-middle mr-2 mb-1"></vue-feather>
                                    {{ app_name }} in your app: install</a>
                            </template>


                            <li v-if="$page.props.canInviteTeammate && _has_invite"
                                class="text-green-500 mb-3 p-3 rounded bg-green-50 border border-green-100">
                                <vue-feather type="check-circle" class="h-4 w-4 align-middle mr-2 mb-1"></vue-feather>
                                Invite Teammates
                            </li>
                            <inertia-link v-else-if="$page.props.canInviteTeammate"
                                :href="route('teams.show', $page.props.user.current_team)"
                                class="block mb-3 hover:text-gray-800 p-3 rounded bg-gray-50 border border-gray-100"
                                title="Invite Teammates">
                                <vue-feather type="circle" class="h-4 w-4 align-middle mr-2 mb-1"></vue-feather>
                                Invite Teammates <vue-feather type="arrow-right"
                                    class="h-4 w-4 ml-2 align-middle" /></inertia-link>

                        </ul>
                    </div>

                    <div class="col">
                        <div class="max-w-xl ml-auto mr-8 h-full">
                            <div class="relative overflow-hidden mx h-full">

                                <!-- pb-16/9 -->
                                <div class="aspect-w-16 aspect-h-9 mx-4" v-if="tab == 'helpdesk' && tab2 == 'intercom'">
                                    <iframe class="rounded shadow" src="https://www.youtube.com/embed/ijfmCVPT_ZU"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                </div>
                                <div class="aspect-w-16 aspect-h-9 mx-4"
                                    v-else-if="tab == 'helpdesk' && tab2 == 'zendesk'">
                                    <iframe class="rounded shadow" src="https://www.youtube.com/embed/ylfACovSTas"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                </div>
                                <div class="aspect-w-16 aspect-h-9 mx-4"
                                    v-else-if="tab == 'helpdesk' && tab2 == 'jira'">
                                    <iframe class="rounded shadow" src="https://www.youtube.com/embed/lJPm3GQyAO8"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                </div>
                                <img v-else-if="tab == 'helpdesk' && tab2 == 'helpscout'" src="/img/researching.svg"
                                    alt="illustration" class="w-4/5 max-w-xs my-4 mx-auto" />
                                <img v-else-if="tab == 'helpdesk' && tab2 == 'freshchat'" src="/img/researching.svg"
                                    alt="illustration" class="w-4/5 max-w-xs my-4 mx-auto" />
                                <img v-else-if="tab == 'helpdesk' && tab2 == 'freshdesk'" src="/img/researching.svg"
                                    alt="illustration" class="w-4/5 max-w-xs my-4 mx-auto" />
                                <div class="aspect-w-16 aspect-h-9 mx-4" v-else-if="tab == 'inapp'">
                                    <iframe class="rounded shadow" src="https://www.youtube.com/embed/HiQu5D2kjIc"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                </div>
                                <div class="aspect-w-16 aspect-h-9 mx-4" v-else-if="tab == 'standalone' && false">
                                    <iframe class="rounded shadow" src="????" frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                </div>
                                <div class="aspect-w-16 aspect-h-9 mx-4" v-else-if="tab == 'helpdesk'">
                                    <iframe class="rounded shadow" src="https://www.youtube.com/embed/ijfmCVPT_ZU"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                </div>


                                <img v-else src="/img/researching.svg" alt="illustration"
                                    class="w-4/5 max-w-xs my-4 mx-auto" />

                            </div>

                            <!-- <div v-if="!has_onboarding_done" class="mt-4 pr-1 text-right">
                                    <small id="bypass">
                                      <span id="bypassed_onboarding"
                                          class="text-primary hidden">
                                          It’s ok! You’ll find this page in the menu <a :href="route('quick_start')" id="glowhelp"><strong>Help > Quick Start</strong></a> if you need it later.
                                      </span>
                                      <a href="#" id="bypass_onboarding" class="text-gray-500 hover:text-gray-600">
                                        I don’t need to see this page again <vue-feather type="x" class="h-4 w-4 align-middle"></vue-feather>
                                      </a>
                                    </small>
                                </div> -->
                        </div>

                    </div>

                </div>


            </div>
        </div>
    </div>
    <settings-modal ref="settingsModal" :modal_type="modal_type" :widget_settings="widget_settings"
        :snippet_original="snippet_original" :blur_snippet="blur_snippet" :integrations="integrations" />
    <!-- </app-layout> -->
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import QuickStartNav from '@/Layouts/QuickStartNav'
import JetDropdown from '@/Jetstream/Dropdown'
import JetDropdownLink from '@/Jetstream/DropdownLink'
import SettingsModal from '@/Components/Modals/SettingsModal'

export default {
    components: {
        AppLayout,
        QuickStartNav, JetDropdown,
        JetDropdownLink, SettingsModal,
    },
    layout: AppLayout,
    props: [
        'tab', // helpdesk, standalone, inapp
        'tab2', // intercom, zendesk
        'has_customize',
        'has_snippet',
        'has_install',
        'has_invite',
        'has_send',
        'has_require',
        'has_launcher',
        'has_helpdesk',
        'has_onboarding_done',
        'integrations',
        'canInviteTeammate',
        'widget_settings',
        "snippet_original",
        "blur_snippet",
    ],
    data() {
        return {
            modal_type: "",
            _has_customize: this.has_customize, // ok
            _has_snippet: this.has_snippet, // ok
            _has_install: this.has_install, // ok
            _has_invite: this.has_invite,
            _has_send: this.has_send,
            _has_require: this.has_require, // ok
            _has_launcher: this.has_launcher,
            _has_helpdesk: this.has_helpdesk,
            _has_onboarding_done: this.has_onboarding_done,
            domain: this.$page.props.app_url.split('.').slice(-2).join('.'),
            app_name: this.$page.props.app_name
        }
    },
    created() {
        //console.log(this.integrations)
        if (!this.canInviteTeammate) {
            this._has_invite = true
        }
        this.validateOnboarding()
        this.EventBus.on('onboarding_step_validation', (step) => {
            if (step == "onboard_customize") {
                this._has_customize = true
            } else if (step == "install_snippet") {
                this._has_snippet = true
            } else if (step == "first_require") {
                this._has_require = true
            } else if (step == "onboard_install") {
                this._has_install = true
            } else if (step == "onboard_launcher") {
                this._has_launcher = true
            } else if (step == "first_record") {
                this._has_send = true
            }
            this.validateOnboarding()
        });
    },
    beforeUnmount() {
        this.EventBus.off('onboarding_step_validation');
    },
    mounted() {
        //this.EventBus.emit("start.call", "hello")
    },
    methods: {
        validateOnboarding() {
            if (!this._has_onboarding_done) {
                if (this.tab == "helpdesk") {
                    if (this._has_customize && this._has_helpdesk && this._has_invite) {
                        this.set_onboarding_done(false)
                    }
                } else if (this.tab == "standalone") {
                    if (this._has_customize && this._has_require && this._has_send && this._has_invite) {
                        this.set_onboarding_done(false)
                    }
                } else if (this.tab == "inapp") {
                    if (this._has_customize && this._has_launcher && this._has_install && this._has_invite) {
                        this.set_onboarding_done(false)
                    }
                }
            }
        },
        has_integration(name) {
            for (var i = 0; i < this.integrations.length; i++) {
                if (this.integrations[i].name == name) {
                    return true
                }
            }
            return false
        },
        default_integration() {
            if (this.integrations.length > 0) {
                let name = this.integrations[0].name.charAt(0).toUpperCase() + this.integrations[0].name.slice(1);
                return name
            }
            return "choose…"
        },
        hovering(part, hover) {
            this.EventBus.emit("highlight", { button: part, state: hover })
        },
        skip() {
            this.set_onboarding_done(true)
        },
        updateHelpdesk(name) {

        },
        openModal() {
            this.$refs.settingsModal.open()
        },
        set_onboarding_done(andGo = false) {
            let url = this.$page.props.api_url + '/v1/user/set_meta';
            var params = {
                meta: "onboarding",
                value: "yes"
            };
            axios.post(url, params)
                .then(response => {
                    if (response.data) {
                        this._has_onboarding_done = true
                        if (andGo) {
                            this.$inertia.visit(route('library.incoming'))
                        }
                    }
                })
                .catch(e => {
                    console.error(e);
                });
        }

    }
}
</script>
